module.exports = {
    //奖励信息
    InviteCode_My_Event: "InviteCode_My_Event"

    //已邀请的好友
    , InviteCode_BindRole_Event: "InviteCode_BindRole_Event"

    //新增的好友
    , InviteCode_BindRole_Updata_Event: "InviteCode_BindRole_Updata_Event"

    //绑定邀请码
    , BindCode_Invite_Event: "BindCode_Invite_Event"

    //获取邀请码
    , Get_InviteCode_Event: "Get_InviteCode_Event"
};